import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Account } from '../../../clients/widgets/account/types'
import { env } from '../../../../libs/constants'

export const accountsMounted = createEvent<{ id: string }>()

export const convertCurrencyMounted = createEvent<{
  amount: string
  baseCurrency: string
  quoteCurrency: string
}>()

export const getAccounts = fx<{ id: string }, Account[]>({
  method: 'GET',
  url: '/client/{clientId}/accounts',
})

export const convertCurrency = fx<
  {
    amount: string
    baseCurrency: string
    quoteCurrency: string
  },
  {
    convertedAmount: string
    symbol: string
    rate: string
  }
>({
  method: 'POST',
  url: '/convert',
  baseUrl: env.baseUrl && env.baseUrl.replace('/v1', ''),
})

export const $accounts = restore<Account[]>(
  getAccounts.doneData.map((doneData) => doneData.body),
  [],
)

export const $convertedCurrency = restore<{
  convertedAmount: string
  symbol: string
  rate: string
}>(
  convertCurrency.doneData.map((a) => a.body),
  null,
)

sample({
  clock: accountsMounted,
  fn: ({ id }) => {
    return {
      url: `/client/${id}/accounts`,
      query: {
        populate: JSON.stringify(['Account']),
      },
    }
  },
  target: [getAccounts],
})

sample({
  clock: convertCurrencyMounted,
  fn: ({ baseCurrency, quoteCurrency, amount }) => {
    return {
      url: `/convert`,
      body: {
        amount,
        baseCurrency,
        quoteCurrency,
      },
    }
  },
  target: [convertCurrency],
})
